import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-up\"><path d=\"M7.5.965L4.318 4.147s-.354.353 0 .707c.353.353.707.003.707 0L7 2.879V14h1V2.879l1.975 1.975.004.003c.042.038.373.327.703-.003.354-.353 0-.707 0-.707L7.5.965z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol